import { render } from "./MyHome.vue?vue&type=template&id=f41fc5e4&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"

import "./MyHome.vue?vue&type=style&index=0&id=f41fc5e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41fc5e4"]])

export default __exports__